<template>
  <nav>
    <ul class="list-pagination pagination justify-content-center" v-if="total">
      <li class="page-item" :class="{ disabled: isFirstPage }">
        <button class="page-link bg-solid border-0" :class="{ 'text-dark': !isFirstPage }" aria-label="First" @click="firstPage"><i class="bi bi-chevron-double-left"></i></button>
      </li>
      <li class="page-item" :class="{ disabled: isFirstPage }">
        <button class="page-link bg-solid border-0" :class="{ 'text-dark': !isFirstPage }" aria-label="Previous" @click="prevPage"><i class="bi bi-chevron-left"></i></button>
      </li>
      <li v-for="(pageNum, index) in pageList" :key="index" class="page-item" :class="{ active: isCurrentPage(pageNum) }">
        <button class="page-link bg-solid border-0" :class="isCurrentPage(pageNum) ? 'loft-text-highlight' : 'text-dark'" @click="gotoPage(pageNum)">{{ pageNum }}</button>
      </li>
      <li class="page-item" :class="{ disabled: isLastPage }">
        <button class="page-link bg-solid border-0" :class="{ 'text-dark': !isLastPage }" aria-label="Next" @click="nextPage"><i class="bi bi-chevron-right"></i></button>
      </li>
      <li class="page-item bg-solid" :class="{ disabled: isLastPage }">
        <button class="page-link bg-solid border-0" :class="{ 'text-dark': !isLastPage }" aria-label="Last" @click="lastPage"><i class="bi bi-chevron-double-right"></i></button>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'ListPagination',
  props: {
    total: {
      type: Number,
      default: 0
    },
    page: {
      type: Number,
      default: 0
    },
    limit: {
      type: Number,
      default: 0
    }
  },
  data: function () {
    return {
      displayCount: 7
    }
  },
  computed: {
    currentPage: function () {
      return Number(this.page) + 1
    },
    totalPages: function () {
      if (!this.total || !this.limit) {
        return 1
      }
      var pages = this.total / this.limit
      var ret = parseInt(pages)
      if (ret !== pages) {
        ret++
      }
      return ret
    },
    pageList: function () {
      // show displayCount pages around the current page
      if (this.currentPage !== null) {
        var ret = []
        var pageNum
        var startPage
        var endPage

        startPage = Number(this.currentPage) - (this.displayCount - 1) / 2
        if (startPage < 1) {
          startPage = 1
        }
        endPage = startPage + (this.displayCount - 1)
        if (endPage > this.totalPages) {
          endPage = this.totalPages
          startPage = endPage - (this.displayCount - 1)
          if (startPage < 1) {
            startPage = 1
          }
        }
        // 1-based page number
        for (pageNum = startPage; pageNum <= endPage; ++pageNum) {
          ret.push(pageNum)
        }
        return ret
      }
      return null
    },
    isFirstPage: function () {
      if (!this.currentPage || !this.totalPages) {
        return true
      }
      return (Number(this.currentPage) === 1)
    },
    isLastPage: function () {
      if (!this.currentPage || !this.totalPages) {
        return true
      }
      return (Number(this.currentPage) === Number(this.totalPages))
    }
  },
  methods: {
    isCurrentPage: function (pageNum) {
      return (Number(this.currentPage) === Number(pageNum))
    },
    firstPage: function () {
      if (this.isFirstPage) {
        return
      }
      this.gotoPage(1)
    },
    prevPage: function () {
      if (this.isFirstPage) {
        return
      }
      this.gotoPage(this.currentPage - 1)
    },
    nextPage: function () {
      if (this.isLastPage) {
        return
      }
      this.gotoPage(this.currentPage + 1)
    },
    lastPage: function () {
      if (this.isLastPage) {
        return
      }
      this.gotoPage(this.totalPages)
    },
    gotoPage: function (pageNum) {
      var toPage = Number(pageNum) - 1
      if (Number(this.page) !== toPage) {
        this.$emit('page', toPage)
      }
    }
  }
}
</script>
